import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'

const persistConfig = {
	key: 'betscycle-bets-admin',
	storage,
	blacklist: [],
	whitelist: ['auth'],
}

export default (reducers) => persistReducer(persistConfig, reducers)
